module.exports = __webpack_public_path__ + "img/symbol_1.27d96599.png";